exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0e873ea0] .el-loading-mask{background-color:transparent!important}", ""]);

// exports
